import React, { useContext, useEffect, useState } from "react";
import { ButtonRenderProps, ContentSection, depascalize, LabeledText } from "sprint-common-web";

import { DynamicSubtitleType } from "../../../../common/types/DynamicSubtitleType";
import { MuxerType } from "../../../../common/types/MuxerType";
import { MuxSpecification } from "../../../../common/types/MuxSpecification";
import { OrderProxyType } from "../../../../orders/common/types/OrderProxyType";
import { SystemPlatformDetailsContext } from "../context/SystemPlatformDetailsContext";
import { SystemPlatformDetailsEncodeConfigurationItem } from "../SystemPlatformDetailsItem";
import { EditEncodeConfigurationButton } from "./edit/EditEncodeConfigurationButton";

export const EncodeConfigurationSection: React.VFC = () => {
    const [encodeConfiguration, setEncodeConfiguration] = useState<SystemPlatformDetailsEncodeConfigurationItem>();

    const { systemPlatformDetailsItem, isLoading } = useContext(SystemPlatformDetailsContext);

    const { encodeConfiguration: encodeConfigurationItem } = systemPlatformDetailsItem;

    const muxSpecificationDisplayName = getMuxSpecificationDisplayName(encodeConfigurationItem.muxSpecification);
    const audioProxyType = encodeConfiguration?.audioProxyType
        ? depascalize(OrderProxyType[encodeConfiguration.audioProxyType])
        : "";
    const muxSubtitleType = encodeConfiguration?.muxSubtitleType
        ? depascalize(DynamicSubtitleType[encodeConfiguration.muxSubtitleType])
        : "";

    const copySubtitleType = encodeConfiguration?.copySubtitleType
        ? depascalize(DynamicSubtitleType[encodeConfiguration.copySubtitleType])
        : "";

    const editEncodeConfigurationButton: ButtonRenderProps = {
        render: EditEncodeConfigurationButton
    };

    useEffect(() => {
        if (encodeConfigurationItem) {
            setEncodeConfiguration(encodeConfigurationItem);
        }
    }, [encodeConfigurationItem]);

    return (
        <ContentSection header="Configuration" buttons={[editEncodeConfigurationButton]} isLoading={isLoading}>
            <LabeledText label="Audio proxy type" value={audioProxyType} />
            <LabeledText label="Mux specification" value={muxSpecificationDisplayName} maxLength={40} />
            <LabeledText label="Mux subtitle type" value={muxSubtitleType} />
            <LabeledText label="Sidecar subtitle type" value={copySubtitleType} />
            <LabeledText
                label="Subtitles target file name"
                value={encodeConfiguration?.subtitlesTargetFileName}
                maxLength={40}
            />
            <LabeledText label="Closed caption code" value={encodeConfigurationItem.closedCaptionCode} />
            <LabeledText label="Subtitles caption code" value={encodeConfigurationItem.subtitlesCaptionCode} />
            <LabeledText
                label="Language specification"
                value={encodeConfiguration?.languageSpecification?.name}
                maxLength={40}
            />
        </ContentSection>
    );
};

const getMuxSpecificationDisplayName = (muxSpecification: MuxSpecification | undefined) => {
    if (!muxSpecification) {
        return "";
    }

    return `${MuxerType[muxSpecification.muxerType]}-${muxSpecification.name}`;
};
